import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../../../store/request/loginRequest';

const useLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogin = async (e) => {
        e.preventDefault();
        const data = await dispatch(loginUser(username, password));
        if (data.status !== 0) {
            console.log('Data', data);
            navigate('/dashboard', data.data.user.token);
        }
        return data;
    };

    return { username, setUsername, password, setPassword, handleLogin };
};

export default useLogin;
